import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import PaymentWayCombo from '../combos/PaymentWayCombo';
import SchoolCombo from '../combos/SchoolCombo';

export default function SchoolPayment(props) {
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    const [school, setSchool] = useState({});
    const [paymentWay, setPaymentWay] = useState(0);
    const [payDate, setPayDate] = useState(0);
    const [amount, setAmount] = useState(0);
    const [traceno, setTraceno] = useState("");
    const [comment, setComment] = useState("");


    useEffect(() => {
      setLoading(true);
      

      var params = {login:util.getTrustedUser(), schoolId:"", searchText:"", fromAmount:0, toAmount:0, fromDate:0, toDate:0, lastIndex:0, pageSize:0};
      var url = config.Server+`/payment/school-payment/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }, []);

    const addNewItem = function(){
      setCurrentItem(null);
      setSchool({});
      setPaymentWay(0);
      setPayDate(0);
      setAmount(0);
      setTraceno("");
      setComment("");
      setEditFormVisible(true);
    }
    const onRowEditClick = function(row) {
      setCurrentItem(row);
      setSchool(row.school);
      setPaymentWay(row.paymentWay);
      setPayDate(row.payDate);
      setAmount(row.amount);
      setTraceno(row.traceno);
      setComment(row.comment);
      setEditFormVisible(true);        
    }
    const onRowDeleteClick = function(row) {
      setCurrentItem(row);
      setConfirmDeleteVisible(true);
    }
    const closeEditDialog = function(){
      setEditFormVisible(false);
    }
    const deleteItem = function(){
      setDeleting(true);
      var id = currentItem.id;
      var params = {login:util.getTrustedUser(), id:id};
      var url = config.Server+`/payment/school-payment/delete`;
        axios
            .post(url, params )
            .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  for(var i=0;i<tmp.length;i++){
                    if(tmp[i].id === id){
                      tmp.splice(i, 1);
                      break;
                    }
                  }
                  setCurrentItem(null);
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setDeleting(false);
                  setConfirmDeleteVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setDeleting(false);
              }
            })
            .catch(error => {
              setDeleting(false);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }
   const checkDataEntry = function(){
        if(school == null){
            setErrorMessage("مدرسه را انتخاب کنید");
            setErorVisible(true);
            return false;
        }
        if(school.id == null){
            setErrorMessage("مدرسه را انتخاب کنید");
            setErorVisible(true);
            return false;
        }
        if(school.id == ""){
            setErrorMessage("مدرسه را انتخاب کنید");
            setErorVisible(true);
            return false;
        }
        if((paymentWay == 0)||(paymentWay == "")||(paymentWay == null)){
            setErrorMessage(" روش پرداخت را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if((payDate == 0)||(payDate == "")||(payDate == null)){
            setErrorMessage("تاریخ پرداخت را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if((amount == 0)||(amount == "")||(amount == null)){
            setErrorMessage("مقدار را را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(traceno.trim().length == 0){
            setErrorMessage("نوع تخفیف را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(comment.trim().length == 0){
            setErrorMessage("شرح را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
      if(!checkDataEntry()) return;

      setSaving(true);
      var id = "";
      if(currentItem != null){
        id = currentItem.id;
      }
      var params = {login:util.getTrustedUser(), id:id, schoolId:school.id, paymentWay:paymentWay.id, payDate:payDate, amount:amount, traceno:traceno, comment:comment};
      var url = config.Server+`/payment/school-payment/save`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  if(id === ""){
                    tmp.push(response);
                  }
                  else{
                    for(var i=0;i<tmp.length;i++){
                      if(tmp[i].id === id){
                        tmp[i] = {
                          id:id, 
                          school:school, 
                          paymentWay:paymentWay, 
                          payDate:payDate, 
                          amount:amount, 
                          traceno:traceno, 
                          comment:comment
                        }
                        setCurrentItem(tmp[i]);
                        break;
                      }
                    }
                  }
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setSaving(false);
                  setEditFormVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{closeEditDialog()}} saving={saving} />
        )
    } 
    const onComboChange = function(name, value){
      if(name == 'paymentWay'){
        setPaymentWay(value);
        return
      }
      else if(name == 'school'){
        setSchool(value);
        return
      }
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "paymentWay") setPaymentWay(val);
        else if(name === "payDate") setPayDate(val);
        else if(name === "amount") setAmount(val);
        else if(name === "traceno") setTraceno(val);
        else if(name === "comment") setComment(val);
    }
    
    const setRowActions = function(row) {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" rounded severity="success" size="small"  style={{ margin: "0px 3px" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
                <Button icon="pi pi-trash" rounded severity="danger" size="small"  style={{ margin: "0px 3px" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
            </React.Fragment>
        );
    }

    return(      
      <>   
       <div className="card">
          <div className="page-caption">لیست پرداخت های مدارس</div>
          {
            loading?
                    <DataTable value={LoadingRows}  className="p-datatable-striped">
                        <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                        <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                    </DataTable>
            :
              <>
                <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                  <Button label="افزودن به لیست" icon="pi pi-plus" onClick={()=>addNewItem()} severity="secondary" iconPos="right" />
                </div>
                
                <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id"  selection={currentItem}  onSelectionChange={(e) => {setCurrentItem(e.value)}}>
                        <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                        <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                        {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                        <Column field="isConfirmed" body={(row)=> row.isConfirmed? "تایید" : "تایید نشده"} header={"وضعیت"} sortable className="list-cell-text-align"></Column>
                        <Column field="school.schoolName" body={(row)=> row.school.schoolName} header={"مدرسه"} sortable className="list-cell-text-align"></Column>
                        <Column field="paymentWay.title" body={(row)=> row.paymentWay.title} header={"روش پرداخت"} sortable className="list-cell-text-align"></Column>
                        <Column field="amount" body={(row) => util.SeperatePrice(row.amount)} header={"مقدار"} sortable className="list-cell-text-align"></Column>
                        <Column field="payDate" body={(row) => util.SeperateDate(row.payDate)} header={"تاریخ پرداخت"} sortable className="list-cell-text-align"></Column>
                        <Column field="traceno" header={"کد رهگیری"} sortable className="list-cell-text-align"></Column>
                        <Column field="comment" header={"شرح"} sortable className="list-cell-text-align"></Column>
                        <Column body={(row) => setRowActions(row)} exportable={false} style={{ maxWidth: '6rem' }}></Column>
                </DataTable>
              </>
          }           
       </div>
       {
        editFormVisible?
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                    header="ثبت پرداخت های مدرسه" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
                      <table style={{width:"100%"}}>
                        <tbody>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <SchoolCombo returnFullItem={true} includeActive={true} includeInActive={true} value={school} onChange={(val) => onComboChange('school', val)} />
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td colSpan={2}>
                              <PaymentWayCombo returnFullItem={true} value={paymentWay} onChange={(val) => onComboChange('paymentWay', val)} />
                            </td>
                          </tr>
                          <tr><td colSpan={2}>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={payDate} onChange={(e)=>{onInputChange(e, "payDate")}} id="code" keyfilter="int" maxLength={10} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">تاریخ پرداخت</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={amount} onChange={(e)=>{onInputChange(e, "amount")}} id="payDate" keyfilter="int" maxLength={10} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">مقدار</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={traceno} onChange={(e)=>{onInputChange(e, "traceno")}} id="traceno" keyfilter="" maxLength={30} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">کد رهگیری</label>
                              </FloatLabel>
                            </td>
                          </tr>  
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={comment} onChange={(e)=>{onInputChange(e, "comment")}} id="comment" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">شرح</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                        </tbody>
                      </table>

        </Dialog>
        :
        <></>
       }
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
      </>  
    );
}
